import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TheRaveGameMode} from "../gameflow/TheRaveGameMode";
import {IWinRatioConfig} from "../../core/config/WinRatio";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TheRave} from "../TheRave";
import {TheRaveParsedData} from "../server/data/TheRaveParsedData";

export class TheRaveSound {
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";
    public static REELS_SPINNING: string = "reelsSpinning";
    public static TINY_WIN = "winTiny";
    public static SMALL_WIN = "winSmall";
    public static MEDIUM_WIN = "winMedium";
    public static LARGE_WIN = "winLarge";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static MAIN_GAME_MUSIC: string = "bgMain";
    public static NORMAL_GAME_MUSIC: string = "bgMain";
    public static FREESPIN_GAME_MUSIC: string = "bgFs1";
    public static FREESPIN_INTRO_MUSIC: string = "bgFs1Intro";
    public static FREESPIN_END_MUSIC: string = "bgFs1Ends";
    public static FS_OUTRO_COUNTUP_END: string = "winLarge";
    public static FREESPIN_SUPER_GAME_MUSIC: string = "bgFs3";
    public static FREESPIN_SUPER_INTRO_MUSIC: string = "bgFs3Intro";
    public static FREESPIN_SUPER_END_MUSIC: string = "bgFs3Ends";
    public static M_TO_M1: string = "m1Convert";

    public static XWAY_SYMBOL_LANDING: string = "xWaysLanding";
    public static XWAY_SYMBOL_EXPAND: string = "xWaysExpand";
    public static XWAY_SYMBOL_EXPAND_FAST: string = "xWaysExpandFast";

    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_WIN: string = "scatterAnticipationWin";
    public static SCATTER_ANTICIPATION_FAIL: string = "scatterAnticipationFail";
    public static SCATTER_LANDING: string[] = ["scatter1", "scatter2", "scatter3", "scatter4", "scatter5"];
    private static _currentMusic: string;
    private static _capWinPlaying: boolean = false;
    private static _fsIntroClicked: boolean = false;
    private static _anticipationPlaying: boolean = false;
    private _once: boolean = false;

    constructor() {
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf): void {
        if (conf.name === TheRaveSound._currentMusic) {
            return;
        }

        if (TheRaveSound._currentMusic != null) {
            if (fadeOutConf) {
                const fade = TheRaveSound.soundPlayer.fadeTrack(fadeOutConf);
                if (fade) {
                    const fadeName = this._currentMusic;
                    fade.player.once("fade", () => {
                        TheRaveSound.soundPlayer.stopTrack(fadeName)
                    });
                }
            } else {
                TheRaveSound.soundPlayer.stopTrack(TheRaveSound._currentMusic);
            }
        }

        //console.log("SEEK RAND NAME: " + conf.name);
        TheRaveSound.soundPlayer.playTrack(conf);
        TheRaveSound.randomStart(conf.name);
        Logger.logDev("sound: " + conf.name)
        if (fadeInConf) {
            TheRaveSound.soundPlayer.fadeTrack(fadeInConf);
        }
        TheRaveSound._currentMusic = conf.name;
    }

    public static reSwitchMusicONSoundLoaded(): void {
        const rand: number = Math.round(Math.random());
        const to: number = (rand > 0) ? 403.141 + 5 : 5
        //TheRaveSound.randomStart(TheRaveSound._currentMusic, rand);
    }

    public static randomStart(name: string, rand?: number): void {
        if (name === "bgMain") {
            const randomInt: number = rand || Math.round(Math.random());
            Logger.logDev("SEEKING TO SECOND: " + (randomInt > 0) ? "217.143" : "0" + " on track: " + name);
            TheRaveSound.soundPlayer.fetchSoundPlayer(name)?.seek((randomInt > 0) ? 403.141 : 0);
        }
    }

    public static getMusicNameByMode(mode: GameMode | string): string {
        switch (mode) {
            case GameMode.FREESPIN:
                this._fsIntroClicked = true;
                return TheRaveSound.FREESPIN_GAME_MUSIC;
            case TheRaveGameMode.FREESPIN_SUPER:
                this._fsIntroClicked = true;
                return TheRaveSound.FREESPIN_SUPER_GAME_MUSIC;
            default:
                return TheRaveSound.MAIN_GAME_MUSIC;
        }
    }

    public static bgFsIntroStart(fromMain: boolean = false): void {
        this._fsIntroClicked = false;
        const introStartSound: string = "bgFsIntroStart";
        const p = this.soundPlayer.playTrack({name: introStartSound, repeat: 0});
        Logger.logDev("sound: " + introStartSound)
        if (p) {
            p.player.loop(false);
            p.player.once("end", () => this.soundPlayer.stopTrack(introStartSound));
        }
    }

    public static anticipationStart(): void {
        this._anticipationPlaying = true;
        const fadeDuration: number = 700;
        if (TheRaveSound._currentMusic != null) {
            TheRaveSound.soundPlayer.fadeTrack({
                name: TheRaveSound._currentMusic,
                from: 1,
                to: 0.7,
                duration: fadeDuration
            });
            Logger.logDev("fade out sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
            //console.log("fade out sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
        }
    }

    public static anticipationStop(): void {
        if (this._anticipationPlaying) {
            const fadeDuration: number = 700;
            if (TheRaveSound._currentMusic != null) {
                TheRaveSound.soundPlayer.fadeTrack({
                    name: TheRaveSound._currentMusic,
                    from: 0.7,
                    to: 1,
                    duration: fadeDuration
                });
                this._anticipationPlaying = false;
                Logger.logDev("fade in sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
                //console.log("fade in sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
            }
        }
    }

    public static capWinStart(): void {
        this._capWinPlaying = true;
        const soundName: string = "capWinStart",
            fadeDuration: number = 2000;
        TheRaveSound.soundPlayer.playTrack({name: soundName, repeat: 0});
        Logger.logDev("Play sound: " + soundName + " repeat: " + 0);
        if (TheRaveSound._currentMusic != null) {
            TheRaveSound.soundPlayer.fadeTrack({
                name: TheRaveSound._currentMusic,
                from: 1,
                to: 0,
                duration: fadeDuration
            });
            Logger.logDev("fade out sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
        }
    }

    public static capWinStop(): void {
        this._capWinPlaying = false;
        TheRaveSound.playSoundEffect("capWinEnds");
        TheRaveSound.stopSoundEffect("capWinLoop");
        if (TheRaveSound._currentMusic != null) {
            TheRaveSound.soundPlayer.stopTrack(TheRaveSound._currentMusic);
        }
        const conf: IPlayTrackConf = {name: TheRaveSound.MAIN_GAME_MUSIC, volume: 0},
            fadeInConf: IFadeTrackConf = {name: TheRaveSound.MAIN_GAME_MUSIC, from: 0, to: 1, duration: 2000};
        TheRaveSound.soundPlayer.playTrack(conf);
        Logger.logDev("sound: " + conf.name)
        if (fadeInConf) {
            TheRaveSound.soundPlayer.fadeTrack(fadeInConf);
        }
        TheRaveSound._currentMusic = conf.name;
    }

    public static capWinLoop(): void {
        if (this._capWinPlaying) {
            TheRaveSound.playSoundEffect("capWinLoop", 10000);
        }
    }

    public static bgFsEnd(currentMode: string): void {
        this._fsIntroClicked = false;
        const gameData: TheRaveParsedData = TheRave.model.currentParsedData;
        const fsTotalNum: number = gameData.freespinsLeft + gameData.numberOfFreespinsPlayed;
        const soundName: string = `bgFs${fsTotalNum === 8 ? 2 : (fsTotalNum === 10 ? 3 : 1)}Ends`;
        const p = this.soundPlayer.playTrack({name: soundName, repeat: 0});
        //console.log("sound: " + soundName)
        if (p) {
            p.player.loop(false);
            p.player.once("end", () => this.soundPlayer.stopTrack(soundName));
        }
    }

    public static playSoundEffect(soundName: string, repeat: number = 0): void {
        TheRaveSound.soundPlayer.playTrack({name: soundName, repeat: repeat});
        Logger.logDev("Play sound: " + soundName + " repeat: " + repeat);
    }

    public static stopSoundEffect(soundName: string): void {
        TheRaveSound.soundPlayer.stopTrack(soundName);
        Logger.logDev("Stop sound: " + soundName);
    }

    public static startBigwinSound(): void {
        const soundName: string = "bigwinInitialWin",
            fadeDuration: number = 1000;
        TheRaveSound.soundPlayer.playTrack({name: soundName, repeat: 0});
        Logger.logDev("Play sound: " + soundName + " repeat: " + 0);
        if (TheRaveSound._currentMusic != null) {
            TheRaveSound.soundPlayer.fadeTrack({
                name: TheRaveSound._currentMusic,
                from: 1,
                to: 0,
                duration: fadeDuration
            });
            Logger.logDev("fade out sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
        }
    }

    public static stopBigwinSound(): void {
        for (let i: number = 1; i < 7; i++) {
            TheRaveSound.soundPlayer.stopTrack(`bigwinLevel${i}`);
        }
        const soundName: string = `bigwinEnds${TheRave.model.parsedGameData.currentWinRatioConfig!.bigWinLevel < 4 ? "1-4" : "5-6"}`,
            fadeDuration: number = 2000;
        TheRaveSound.soundPlayer.playTrack({name: soundName, repeat: 0});
        Logger.logDev("Play sound: " + soundName + " repeat: " + 0);
        if (TheRaveSound._currentMusic != null) {
            TheRaveSound.soundPlayer.fadeTrack({
                name: TheRaveSound._currentMusic,
                from: 0,
                to: 1,
                duration: fadeDuration
            });
            Logger.logDev("fade in sound: " + TheRaveSound._currentMusic + " duration: " + fadeDuration);
        }
    }

    public static playNormalWinSound(winRatioConfig: IWinRatioConfig): void {
        let soundName: string = "";
        switch (winRatioConfig.name) {
            case "Tiny":
                soundName = TheRaveSound.TINY_WIN;
                break;
            case "Small":
                soundName = TheRaveSound.SMALL_WIN;
                break;
            case "Medium":
                soundName = TheRaveSound.MEDIUM_WIN;
                break;
            case "Large":
                soundName = TheRaveSound.LARGE_WIN;
                break;
            default:
                soundName = "";
                break;
        }
        TheRaveSound.soundPlayer.playTrack({name: soundName});
        Logger.logDev("Play sound: " + soundName);
    }

    public static playNormalWinBetLineSound(winRatioConfig: IWinRatioConfig): void {
        let soundName: string = "";
        if (winRatioConfig.name!.indexOf("Big") > -1) {
            soundName = "Bigwin";
        } else {
            switch (winRatioConfig.name) {
                case "Tiny":
                case "Small":
                    soundName = "TinySmall";
                    break;
                case "Medium":
                    soundName = "Medium";
                    break;
                case "Large":
                    soundName = "Large";
                    break;
                default:
                    soundName = "TinySmall";
                    break;
            }
        }

        this.playSoundEffect(`betlineGlow${soundName}`);
    }
}